import { render, staticRenderFns } from "./feature-item.vue?vue&type=template&id=3a5dd34e"
import script from "./feature-item.vue?vue&type=script&lang=js"
export * from "./feature-item.vue?vue&type=script&lang=js"
import style0 from "./feature-item.vue?vue&type=style&index=0&id=3a5dd34e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports